export const ACTA_NO_VALIDADA = {
  value: 2,
  label: 'No validado'
};
export const ACTA_CANCELADA = {
  value: 3,
  label: 'Cancelado'
};
export const ACTA_VALIDADA = {
  value: 4,
  label: 'Validado'
};
